module.exports = __webpack_public_path__ + "static/media/single-project-banner.7f3670de.jpg";